import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a role name.'), required)
      },
      description: {
        required: helpers.withMessage(i18n.global.t('Please enter a role description.'), required)
      },
      permission_ids: {
        required: helpers.withMessage(i18n.global.t('Please select at least one permission.'), required)
      }
    }
  }
};
